<template>
	<div class="company-advanced-card">
		<span class="company-advanced-card__item">
			Company Name {{ item.companyName }}
		</span>
		<span class="company-advanced-card__item">
			Company Nickname {{ item.companyNickname }}
		</span>
		<span class="company-advanced-card__item">
			Dominion ID # {{ item.dominionID }}
		</span>
		<span class="company-advanced-card__item">
			Dealer Client #: {{ item.dealerCustomer }}
		</span>
		<span class="company-advanced-card__item">
			Company Code {{ item.companyCode }}
		</span>
		<span class="company-advanced-card__item">
			Go Live Date {{ item.liveDate }}
		</span>
		<div class="company-advanced-card__item">
			Company Color {{ item.companyColor }}
			<span
				class="company-advanced-card__color"
				style="{backgroundColor: item.companyColor}"
			/>
		</div>
		<span class="company-advanced-card__item">
			Inactive {{ item.inactive ? 'Yes' : 'No' }}
		</span>
		<span class="company-advanced-card__item">
			Audit Log On {{ item.auditLogOn ? 'Yes' : 'No' }}
		</span>
		<span class="company-advanced-card__item">
			Company Groups {{ item.companyColor }}
		</span>
	</div>
</template>

<script>
export default {
	name: 'CompanyShippingCard',
	components: {},
	props: {
		item: {
			type: Object,
			default: () => {}
		}
	}
};
</script>

<style lang="scss" scoped>
@import '@/scss/5-objects/_cards.scss';

.company-advanced-card {
	&__item {
		display: block;
	}

	&__color {
		width: 128px;
		height: 48px;
	}
}
</style>
